import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map, tap} from 'rxjs/operators';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {FileSaverService} from 'ngx-filesaver';

@Injectable()
export class TrankInvitationsDetailsService extends GridService {
  _FileSaverService: FileSaverService = inject(FileSaverService);
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(
      http,
      configService,
      eventsEmitterService,
      router,
      logger,
      'TrackInvitationsDetailsService',
    );
  }

  loadBean(userId: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'FormDataService/data?formCd=Onboarding_Main_Form&userId=' + userId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  loadBeanIsClient(userId: any, formCode): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'FormService/formClientList?userId=' + userId + '&formCd=' + formCode;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }
  save(formVal: Object, id: number): Observable<any> {
    let form = {dataChar: JSON.stringify(formVal)};
    let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Onboarding_Main_Form&userId=' + id;
    return this.request(serviceUrl, this.setPostParams(form)).pipe(catchError(super.handleError));
  }
  getDocumentList(userId, isAdmin): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'FileUploadService/getDocumentList?userId=' + userId + '&isAdmin=' + isAdmin;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getKYCList(userId) {
    let serviceUrl = this.baseUrl + 'FileUploadService/getKYCList?userId=' + userId;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getAmlList(userId) {
    let serviceUrl = this.baseUrl + 'FileUploadService/getAMLList?userId=' + userId;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getFinacleData(cif) {
    let serviceUrl = this.baseUrl + 'TrackInvitationsDetailsService/getFinData/' + cif;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  saveDocs(docs): Observable<any> {
    let serviceUrl = this.baseUrl + 'TrackInvitationsDetailsService/savedocs';
    return this.request(serviceUrl, this.setPostParams(docs)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  saveClient(client): Observable<any> {
    let serviceUrl = this.baseUrl + 'TrackInvitationsDetailsService/saveClient';
    return this.request(serviceUrl, this.setPostParams(client)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  changeStatus(formVal: Object, id: number, status: string): Observable<any> {
    let form = {dataChar: JSON.stringify(formVal)};
    let serviceUrl =
      this.baseUrl +
      'TrackInvitationsDetailsService/changeStatus/' +
      id +
      '?formCd=Onboarding_Main_Form&status=' +
      status;
    return this.request(serviceUrl, this.setPostParams(form)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getBanks(): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'TrackInvitationsDetailsService/getBanks?bankId=&bankName=&countryId';
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  downloadFile(regcmpdocId: any, userId: any, file): Observable<Blob> {
    var namex = file.fileName;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options = {
      headers: headers,
      responseType: 'blob',
    };
    return this.request(
      this.baseUrl +
        'FileUploadService/downloadFile?' +
        'regcmpdocId=' +
        regcmpdocId +
        '&userId=' +
        userId +
        '&doctype=REG',
      options,
    ).pipe(
      tap((res) => {
        this._FileSaverService.save(res, namex);
      }),
      catchError(this.handleError),
    );
  }

  getFlow(regSecId: number): Observable<any> {
    let serviceUrl =
      this.baseUrl + 'TrackInvitationsDetailsService/statesFlow?regSecId=' + regSecId;
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getFields(userId): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'FormDataService/configData?userId=' +
      userId +
      '&formCd=Backoffice_Main_Form&langId=' +
      this.getActiveLang();
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  deleteFile(regcmpdocId: any): Observable<any> {
    let serviceUrl = this.baseUrl + "FileUploadService/deleteFile?doctype=''";
    return this.request(serviceUrl, this.setPostParams(regcmpdocId.value)).pipe(
      catchError(super.handleError),
    );
  }
  getBankBranches(): Observable<any>{
    let serviceUrl = this.baseUrl + 'TrackInvitationsDetailsService/getBankBranches';
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  getClientBranches(): Observable<any>{
    let serviceUrl = this.baseUrl + 'TrackInvitationsDetailsService/getClientBranches';
    return this.request(serviceUrl /* , this.setGetParams(bean) */).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
}
